import { Button, Flex, Input, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import FilterDropdown from "../../../Reuseable/actionHeader/Filter";
import { formatCurrency } from "../../../assets/helpers";
import { fetchUserFilters } from "../../../store/filters";
import { fetchBankDashboard } from "../../../store/portfolioSlice";
import { fetchTelecallerFeedbackCases } from "../../../store/telecaller/cases";
import { CasesFeedbackModal } from "../FeedbackModal/CasesFeedback";
import './CasesFeedback.scss';
const CasesFeedback = () => {
  const { bankDashboard = [], bankDashboard_loading } = useSelector(
    (state) => state?.portfolio
  );
  const navigate = useNavigate();
  const { format } = useSelector(state => state.priceFormat);

  const { query } = useSelector((state) => state.filters);

  const { feedback_cases, feedback_cases_loading } = useSelector(
    (state) => state?.telecallerCases
  );
  const [selectedPortfolio, setSelectedPortfolio] = useState("all");
  const [params, setParams] = useState({
    page: 1,
    page_size: 10,
  });
  const [selectedCase, setSelectedCase] = useState(null);
  const [opneFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchUserFilters())
    dispatch(fetchBankDashboard())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchTelecallerFeedbackCases({ ...params, ...query }))

  }, [dispatch, params, query, refresh])


  const columns = [
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Loan No.',
      dataIndex: 'loan_no',
      key: 'loan_no',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'POS',
      dataIndex: 'odpos',
      key: 'odpos',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : Number(text).toFixed(2) || "-",
    },

    {
      title: 'Amount Overdue',
      dataIndex: 'amount_overdue',
      key: 'amount_overdue',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : formatCurrency(text, format) || "-",
    },
    {
      title: 'Bank',
      dataIndex: 'bank_name',
      key: 'bank_name',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Disposition',
      dataIndex: 'call_status',
      key: 'call_status',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Feedback Date',
      dataIndex: 'date',
      key: 'date',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Disposition',
      dataIndex: 'call_status',
      key: 'call_status',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },

    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
      render: (text) =>
        feedback_cases_loading ? <Skeleton.Input size="small" active /> : text?.length > 20 ? <Tooltip title={text}>
          {text?.slice(0, 20) + '...'}
        </Tooltip> : text || "-",
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => <Button
        onClick={(e) => {
          e.stopPropagation();
          setOpenFeedbackModal(true);
          setSelectedCase(record);
        }}
      >
        Feedback
      </Button>
    }
  ];

  const onRowClick = (record) => {
    navigate(`/allocation/cases/customer-details/${record?.customer_name}`, {
      state: record,
    });
  }

  return <div className="allocationPage">
    <Flex className="allocationContent cases-feedback-page">
      <Flex
        className="all-buttons"
        gap={15}
        justify="space-between"
        align="center"
        style={{ marginBottom: '20px' }}
      >

        <Input
          placeholder="Search"
          allowClear
          className="searchInput"
          style={{ width: '30%' }}


          onPressEnter={(e) => {
            const value = e.target.value;
            setParams((prev) => ({
              ...prev,
              search: value,
              page: 1,
              page_size: 10,
            }));
          }}
        />

        <Flex gap={10}>
          <FilterDropdown variant="2" />
        </Flex>
      </Flex>
      <ReusableTable
        columns={columns}
        dataSource={feedback_cases_loading ? Array(5).fill({}) : feedback_cases?.results?.
          cases_with_feedback || []}
        totalItems={feedback_cases?.count || 0}
        onRowClick={onRowClick}
        pointer={true}
        CurrentPageNo={params.page}
        pageSize={params.page_size}
        triggerChange={(page, size) => {
          setParams((prev) => ({
            ...prev,
            page: page,
            page_size: size,
          }));
        }}
      />

    </Flex>
    <CasesFeedbackModal
      open={opneFeedbackModal}
      setOpen={setOpenFeedbackModal}
      setRefresh={setRefresh}
      data={{
        ...selectedCase,
        id: selectedCase?.case_id
      }}
    />
  </div>;
};
export default CasesFeedback;